/**
 * Created by seaasun on 2017/11/24.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import order from './order'
import demo from './demo'
import site from './site'
import geo from './geo'
import summary from './summary'
import config from './config'
import reward from './reward'
import user from './user'

Vue.use(Vuex)
// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    order,
    demo,
    geo,
    site,
    summary,
    config,
    reward,
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js